<script setup>
import { computed } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  sopUrl: { type: String, default: '' },
  title: { type: String, default: '' },
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const iframeSrc = computed(() => {
  const match = props.sopUrl?.match(/#G([^#]+)/);
  if (!match) return 'about:blank';
  return `https://viewer.diagrams.net/?dark=auto#G${match[1]}`;
});

const isValid = computed(() => iframeSrc.value !== 'about:blank');

useEventListener(document, 'keydown', e => {
  if (props.show && e.key === 'Escape') emit('close');
});
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isValid"
      class="fixed inset-0 z-[9990] flex items-center justify-center bg-n-alpha-black2 backdrop-blur-[4px] transition-opacity duration-200"
      :class="show ? 'opacity-100' : 'opacity-0 pointer-events-none !z-[-1]'"
      @click.self="show && emit('close')"
    >
      <div
        class="relative flex flex-col w-[95vw] h-[95vh] bg-n-solid-2 rounded-xl overflow-hidden shadow-xl"
      >
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-n-container flex-none"
        >
          <span class="text-sm font-medium text-n-slate-12 truncate">
            {{ title }}
          </span>
          <Button
            ghost
            slate
            icon="i-lucide-x"
            size="sm"
            @click="emit('close')"
          />
        </div>
        <iframe
          :key="iframeSrc"
          :src="iframeSrc"
          :title="t('SOP_VIEWER.BUTTON_LABEL')"
          class="w-full flex-1 border-0 min-h-0"
          sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms"
        />
      </div>
    </div>
  </Teleport>
</template>
